import { render, staticRenderFns } from "./ApproveModel.vue?vue&type=template&id=b8dc5e4c&scoped=true"
import script from "./ApproveModel.vue?vue&type=script&lang=js"
export * from "./ApproveModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dc5e4c",
  null
  
)

export default component.exports